<template>
  <el-dialog
      :title="'选择考场'"
      :visible.sync="subdialogDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <div>

      <el-tree
          :data="orgList"
          show-checkbox
          node-key="org_id"
          ref="tree"
          default-expand-all
          :default-checked-keys="checkList"
          @check-change="handleCheckChange"
          :props="defaultProps"
      >
      </el-tree>

      <div class="flex align-center justify-around padding-lr">
        <el-button class="padding-lr-xl" @click="resetForm">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import {roomList,checkRoom} from "@/api/projectOffice";

export default {
  name: "examCenterDialog",
  props: {
    subdialogDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orgList: [],
      checkList: [],
      defaultProps: {
        children: "rooms",
        label: "org_name"
      },
    }
  },
  created() {
  },
  methods: {
    async getList() {
      let _data = await roomList(this.$route.query.id)
      _data.data.map(item=>{
        item.org_name = item.letter
      })
      this.orgList = _data.data
    },
    resetForm() {
      this.$emit('cancelDialog', false)
    },
    submitForm() {
      if(this.checkList.length>0){
        this.poseExam()
      }else{
        this.$message.error('请选择接收考试的机构')
      }

    },
    async poseExam(){
      let _state = await checkRoom(this.$route.query.id,this.checkList.join(','))
      this.$message.success(_state.msg)
      this.$emit('cancelDialog', false)
    },
    handleCheckChange() {
      let _arr = this.$refs.tree.getCheckedKeys();
      this.checkList = _arr.filter((num) => {
        return num !== undefined;
      })
    },
  },
  watch: {
    subdialogDialog() {
      if(this.subdialogDialog) this.getList()
    }
  }
}
</script>

<style scoped lang="scss">

</style>